<div class="form-control">
    <label>{{ selectLabel }}</label>
    <ng-select
        #select
        [placeholder]="placeholder"
        [items]="data"
        [bindLabel]="bindLabel"
        [bindValue]="bindValue"
        [multiple]="multipleSelection"
        [virtualScroll]="true"
        [closeOnSelect]="closeOnSelect"
        [searchable]="searchable"
        [clearSearchOnAdd]="true"
        [formControl]="control"
        [notFoundText]="notFoundText | translate"
        (change)="onValueChange()"
        (blur)="markAsTouched()"
    >
        <ng-template ng-header-tmp *ngIf="selectAllAvailable">
            <button (click)="selectAll()" class="btn btn--secondary">{{ 'SHARED.SELECT-ALL' | translate }}</button>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">{{ item[bindLabel] | translate }}</span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <div class="checkbox-group">
                <input type="checkbox" [ngModel]="item$.selected" /> {{ item[bindLabel] | translate }}
                <span class="checkmark"></span>
            </div>
        </ng-template>
    </ng-select>
    <ng-content></ng-content>
</div>
